export const mpsTypes = {
    1 : "Лек автомобил",
    2 : "Електромобил",
    3 : "Товарен автомобил",
    4 : "Мотоциклет",
    6 : "Мотопед",
    5 : "АТВ",
    7 : "Триколка",
    8 : "Товарно ремарке, полуремарке",
    9 : "Багажно или къмпинг ремарке",
    10 : "Влекач",
    11 : "Микробус, Автобус"
}

export const mpsDesignation = {
    1 : "Лични нужди",
    2 : "Служебна дейност",
    3 : "Таксиметрови услуги",
    6 : "Отдаване под наем (рент-а-кар)",
    5 : "Учебен автомобил",
    9 : "Куриерски услуги",
    4 : "Състезатален автомобил",
    8 : "Специален режим на движение",
    7 : "Превоз на опасни товари"
}

export const fuelType = {
    "1" : "Бензин",
    "2" : "Дизел",
    "3" : "Метан",
    "4" : "Електродвигател",
    "5" : "Дизел/Електро",
    "6" : "Бензин/Електро",
    "7" : "Газ",
    "8" : "Бензин/Газ",
    "9" :"Друго"
}

export const AddContractErrors = {
    VINS_GET_POLICY_INFO_ERROR : "VINS_GET_POLICY_INFO_ERROR",
    NO_DATA_FOUND : "NO_DATA_FOUND",
    VINS_MAKE_PAYMENT_ERROR_UNKNOWN_INSTALLMENTS_NUMBER : "VINS_MAKE_PAYMENT_ERROR_UNKNOWN_INSTALLMENTS_NUMBER"
}

export const requiredVehicleData = {
    make: null,
    model: null,
    vin: null,
    color: null,
    fuelType: null,
    firstRegDate: null,
    maxPower: null,
    seatsCount: null,
    weightF1: null, // && != 0
    weightG: null, // && != 0
}

export const requiredVehicleDataNoEngine = {
    make: null,
    model: null,
    vin: null,
    color: null,
    firstRegDate: null,
    weightF1: null, // && != 0
    weightG: null, // && != 0
}

export const regPropsBG = {
    make            : 'Марка',
    model           : 'Модел',
    vin             : 'Рама',
    color           : 'Цвят',
    fuelType        : 'Гориво',
    firstRegDate    : 'Дата на първа регистрация',
    maxPower        : 'Мощност',
    seatsCount      : 'Брой места',
    weightF1        : 'Технически допустима макс. маса',
    weightG         : 'Маса на превозното средство',
    engineCapacity  : 'Обем на двигателя',
}

export const practiceYearsType = {
    'Под 1 година'  : '0', // needs to be set to '1'
    '1 година'      : '1',
    '2 години'      : '2',
    '3 години'      : '3',
    '4 години'      : '4',
    '5 години'      : '5',
    '5-10 години'   : '9',
    'Над 10 години' : '20'
}

//generalRegistrationType": “0” -> if vehicle is registered

//generalRegistrationType": “1” -> if vehicle is farm machine

//generalRegistrationType": “2” -> if vehicle is not registered

//generalRegistrationType": “3” -> if vehicle is registered with partial data from KAT


// class OffersManager { //errors for offers 

//     private struct Constants {

//         static let INSTALLMENTS_NOT_SUPPORTED_ERROR_MESSAGES = [

//             "INSTALLMENTS_NOT_SUPPORTED_FOR_UNREGISTERED_VEHICLES",

//             "NOT_SUPPORTED_FOR_UNREGISTERED_VEHICLES",

//             "MULTIPLE_INSTALLMENTS_NOT_SUPPORTED_FOR_THIS_VEHICLE_TYPE",

//             "NO_APPLICATIONS_FOR_THIS_VEHICLE_TYPE"]

//         static let APPLICATION_GENERATION_FAILED = "APPLICATION_GENERATION_FAILED"